import React from 'react'
import styles from './MicrositeTriggerBadge.module.css'
import { LogOut, Clock, MousePointer2, Hand } from 'lucide-react'

/**
 * MicrositeTriggerBadge
 * Popup trigger type pill: EXIT_INTENT / DELAY / SCROLL / MANUAL.
 *
 * Usage:
 *   <MicrositeTriggerBadge value={row.triggerType} triggerValue={row.triggerValue} />
 */
const META = {
    EXIT_INTENT: { label: 'Exit intent', icon: LogOut, tone: 'coral' },
    DELAY:       { label: 'Time delay',  icon: Clock,  tone: 'blue' },
    SCROLL:      { label: 'Scroll',      icon: MousePointer2, tone: 'amber' },
    MANUAL:      { label: 'Manual',      icon: Hand,   tone: 'neutral' }
}

const MicrositeTriggerBadge = ({ value, triggerValue }) => {
    const meta = META[value] || META.MANUAL
    const Icon = meta.icon

    let suffix = ''
    if (value === 'DELAY' && triggerValue) suffix = ` (${triggerValue}s)`
    if (value === 'SCROLL' && triggerValue) suffix = ` (${triggerValue}%)`

    return (
        <span className={`${styles.badge} ${styles[`tone_${meta.tone}`]}`}>
            <Icon size={11} />
            {meta.label}{suffix}
        </span>
    )
}

export default MicrositeTriggerBadge